// extracted by mini-css-extract-plugin
export default {"section":"Tp-z","sectionTitle":"Up-z","fieldWrapper":"Vp-z","formField":"Wp-z","disabled":"Xp-z","formLabel":"Yp-z"};